import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SubscribeComponent } from '../../common/subscribe/subscribe.component';

interface Rapport {
    titre: string;
    fichier: string;
    description?: string;
}

interface RapportParAnnee {
    annee: number;
    rapports: Rapport[];
}

@Component({
    selector: 'app-rapports',
    standalone: true,
    imports: [
        RouterLink,
        CommonModule,
        SubscribeComponent,
    ],
    templateUrl: './rapports.component.html',
    styleUrl: './rapports.component.scss'
})
export class RapportsComponent {
    rapportsParAnnee: RapportParAnnee[] = [];
}
